const actions = {
  async acceptInviteHandler({dispatch, getters}, notification) {
    let res = await dispatch('api/genericHandler', ['nav/respondRoomInvite', [notification, "Accepted", 0] ])
    dispatch('analytics/respondToRoomInvite', ['accept', notification])
    if(res.success) dispatch('routing/goToRoom', notification.hostLocationId)

    //decline all other active invites
    let active = getters.getActiveRoomInvites.filter(n => n.id !== notification.id)
    active.forEach(a => dispatch('declineInviteHandler', a))
  },
  async declineInviteHandler({dispatch}, notification) {
    dispatch('api/genericHandler', ['nav/respondRoomInvite', [notification, "Declined", 1] ])
    dispatch('analytics/respondToRoomInvite', ['decline', notification])
  },
  messageInviteHandler({dispatch}, [notification, message]) {
    dispatch('analytics/respondToRoomInvite', ['message', notification, message])
    return dispatch('api/genericHandler', ['nav/respondRoomInvite', [notification, message, 3] ])
  },

  async acceptInviteOnJoiningRoom({getters, dispatch}, roomId) { //check if joining a room which user has a pending active invite for
    if(getters.getCurrentNotification?.hostLocationId === roomId) dispatch('acceptInviteHandler', getters.getCurrentNotification)
  }
};

export default {
  actions
};
